import * as React from 'react';
import Table, { ColumnType } from 'antd/lib/table';
import Flex from 'antd/lib/flex';
import Text from 'antd/lib/typography/Text';
import Icon from '@ant-design/icons';

import { AutomationRun, AutomationStatus } from '@/types';
import { antGrey } from '../styles/globalStyles';
import {
    colorForAutomationStatus,
    displayTextForAutomationStatus,
    iconForAutomationType,
} from '@/helpers/displayHelpers';
import { renderTextWithMarkdownLinks } from '@/helpers/automationHelpers';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';

interface StepAutomationRunsProps {
    automationRuns: AutomationRun[];
}

export const StepAutomationRuns: React.FC<StepAutomationRunsProps> = ({ automationRuns }) => {
    const keyedItems = automationRuns.map((run) => ({
        ...run,
        key: run.id,
    }));

    const columns: ColumnType<AutomationRun>[] = [
        {
            colSpan: 0,
            render: (automationRun: AutomationRun) => {
                const statusText = displayTextForAutomationStatus(automationRun.status);
                const statusColor = colorForAutomationStatus(automationRun.status, false);
                const isFailed = automationRun.status === AutomationStatus.Failed;

                return (
                    <Flex
                        align="center"
                        justify="space-between"
                        style={{
                            width: '100%',
                        }}
                    >
                        <Flex align="center" gap={8}>
                            <Icon
                                component={iconForAutomationType(automationRun.type)}
                                style={{
                                    fontSize: 16,
                                    color: antGrey.grey7,
                                    padding: '0 8px',
                                }}
                            />{' '}
                            <Text style={{ fontSize: 13, color: antGrey.grey8 }}>{automationRun.name}</Text>
                        </Flex>
                        <Flex align="center" gap={8}>
                            <Text style={{ fontSize: 13, color: statusColor, whiteSpace: 'nowrap' }}>
                                {renderTextWithMarkdownLinks(statusText)}
                            </Text>
                            {isFailed && automationRun.statusMessage && (
                                <TooltipInfoIcon
                                    tooltipContent={automationRun.statusMessage}
                                    style={{ color: statusColor, fontSize: 14 }}
                                    tooltipProps={{ placement: 'left' }}
                                />
                            )}
                        </Flex>
                    </Flex>
                );
            },
        },
    ];

    return (
        <Table<AutomationRun>
            size="small"
            locale={{ emptyText: 'No automations' }}
            pagination={false}
            dataSource={keyedItems}
            columns={columns}
            showHeader={false}
        />
    );
};
